// extracted by mini-css-extract-plugin
export default {"external":"ExternalLinkSymbol_external__T8PiP"};